import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "participant-page" }
const _hoisted_2 = { class: "new-toolbarContainer participant-toolbar-container" }
const _hoisted_3 = { class: "participant-left-toolbar" }
const _hoisted_4 = { class: "participant-search-container" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "filter-count-badge"
}
const _hoisted_9 = ["src", "title"]
const _hoisted_10 = {
  key: 0,
  class: "filter-summary-row"
}
const _hoisted_11 = { class: "filter-summary-text" }
const _hoisted_12 = { class: "filter-group" }
const _hoisted_13 = { class: "filter-group-title" }
const _hoisted_14 = { class: "filter-radio-row" }
const _hoisted_15 = { class: "filter-radio-item" }
const _hoisted_16 = { class: "filter-radio-item" }
const _hoisted_17 = { class: "filter-radio-item" }
const _hoisted_18 = { class: "filter-group" }
const _hoisted_19 = { class: "filter-group-title" }
const _hoisted_20 = { class: "filter-radio-row" }
const _hoisted_21 = { class: "filter-radio-item" }
const _hoisted_22 = { class: "filter-radio-item" }
const _hoisted_23 = { class: "filter-radio-item" }
const _hoisted_24 = {
  key: 0,
  class: "filter-group"
}
const _hoisted_25 = { class: "filter-group-title" }
const _hoisted_26 = { class: "filter-items-grid filter-items-grid--2col" }
const _hoisted_27 = ["checked", "onChange"]
const _hoisted_28 = {
  key: 1,
  class: "filter-group"
}
const _hoisted_29 = { class: "filter-group-title" }
const _hoisted_30 = { class: "filter-items-grid filter-items-grid--3col" }
const _hoisted_31 = ["checked", "onChange"]
const _hoisted_32 = {
  key: 2,
  class: "filter-group"
}
const _hoisted_33 = { class: "filter-group-title" }
const _hoisted_34 = { class: "filter-items-grid filter-items-grid--3col" }
const _hoisted_35 = ["checked", "onChange"]
const _hoisted_36 = {
  key: 3,
  class: "filter-group"
}
const _hoisted_37 = { class: "filter-group-title" }
const _hoisted_38 = { class: "filter-items-grid filter-items-grid--3col" }
const _hoisted_39 = ["checked", "onChange"]
const _hoisted_40 = { class: "filter-group" }
const _hoisted_41 = { class: "filter-group-title" }
const _hoisted_42 = { class: "filter-item" }
const _hoisted_43 = { class: "chooser-group-title" }
const _hoisted_44 = ["checked", "onChange"]
const _hoisted_45 = { class: "participant-right-side-toolbar" }
const _hoisted_46 = ["src"]
const _hoisted_47 = ["src"]
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "import-subtitle" }
const _hoisted_50 = { class: "import-section-title" }
const _hoisted_51 = { class: "import-rules" }
const _hoisted_52 = {
  href: "javascript:void(0)",
  class: "import-template-link"
}
const _hoisted_53 = { class: "import-rules-sub" }
const _hoisted_54 = { class: "import-custom-fields" }
const _hoisted_55 = { class: "import-custom-fields-title position-relative" }
const _hoisted_56 = { class: "import-custom-fields-list" }
const _hoisted_57 = {
  key: 0,
  class: "margin-top-20 alert-info-strip"
}
const _hoisted_58 = ["src"]
const _hoisted_59 = { key: 0 }
const _hoisted_60 = {
  key: 0,
  class: "warning-info-strip margin-bottom-10 display-flex align-items-center"
}
const _hoisted_61 = ["src"]
const _hoisted_62 = { class: "margin-left-5" }
const _hoisted_63 = {
  key: 1,
  class: "info-strip margin-bottom-5 display-flex align-items-center"
}
const _hoisted_64 = ["src"]
const _hoisted_65 = { class: "margin-left-5" }
const _hoisted_66 = {
  key: 2,
  class: "alert-info-strip margin-bottom-10"
}
const _hoisted_67 = ["src"]
const _hoisted_68 = { class: "excel-table-scroll" }
const _hoisted_69 = { class: "excel-table" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = ["colspan"]
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { class: "validation-table" }
const _hoisted_74 = { key: 2 }
const _hoisted_75 = { class: "emptyDiv text-center" }
const _hoisted_76 = ["src"]
const _hoisted_77 = { class: "margin-top-30 display-flex flex-direction-column" }
const _hoisted_78 = { class: "font-size-24" }
const _hoisted_79 = { class: "export-subtitle" }
const _hoisted_80 = { class: "export-section-title" }
const _hoisted_81 = { class: "export-radio" }
const _hoisted_82 = ["disabled"]
const _hoisted_83 = ["disabled"]
const _hoisted_84 = { class: "export-section-title export-what-title" }
const _hoisted_85 = ["onUpdate:modelValue", "disabled"]
const _hoisted_86 = {
  key: 0,
  class: "export-children"
}
const _hoisted_87 = ["onUpdate:modelValue", "disabled"]
const _hoisted_88 = ["onClick"]
const _hoisted_89 = { class: "email-type-radio" }
const _hoisted_90 = ["value"]
const _hoisted_91 = { class: "email-type-content" }
const _hoisted_92 = { class: "email-type-label" }
const _hoisted_93 = { class: "email-type-desc" }
const _hoisted_94 = {
  key: 0,
  class: "email-type-last-sent"
}
const _hoisted_95 = { class: "email-template-link-row" }
const _hoisted_96 = {
  key: 0,
  class: "assign-ticket-section"
}
const _hoisted_97 = ["checked", "onChange"]
const _hoisted_98 = { class: "assign-ticket-name" }
const _hoisted_99 = { class: "assign-ticket-price" }
const _hoisted_100 = {
  key: 1,
  class: "assign-ticket-section"
}
const _hoisted_101 = ["checked", "onChange"]
const _hoisted_102 = { class: "assign-ticket-name" }
const _hoisted_103 = { class: "assign-ticket-price" }
const _hoisted_104 = {
  key: 0,
  class: "assign-ticket-section"
}
const _hoisted_105 = ["checked", "onChange"]
const _hoisted_106 = { class: "assign-ticket-name" }
const _hoisted_107 = { class: "assign-ticket-price" }
const _hoisted_108 = {
  key: 1,
  class: "assign-ticket-section"
}
const _hoisted_109 = ["checked", "onChange"]
const _hoisted_110 = { class: "assign-ticket-name" }
const _hoisted_111 = { class: "assign-ticket-price" }
const _hoisted_112 = { class: "assign-group-radio" }
const _hoisted_113 = ["disabled"]
const _hoisted_114 = ["value"]
const _hoisted_115 = { class: "assign-group-radio assign-group-radio--spaced" }
const _hoisted_116 = ["disabled"]
const _hoisted_117 = { class: "edit-profile-header" }
const _hoisted_118 = { class: "edit-profile-info" }
const _hoisted_119 = { class: "edit-profile-name" }
const _hoisted_120 = { class: "edit-profile-meta" }
const _hoisted_121 = { key: 0 }
const _hoisted_122 = { class: "edit-profile-email" }
const _hoisted_123 = { class: "edit-profile-badges" }
const _hoisted_124 = {
  key: 0,
  class: "badge badge-green"
}
const _hoisted_125 = {
  key: 1,
  class: "badge badge-yellow"
}
const _hoisted_126 = {
  key: 2,
  class: "badge badge-red"
}
const _hoisted_127 = {
  key: 3,
  class: "badge badge-gray"
}
const _hoisted_128 = { class: "edit-tabs" }
const _hoisted_129 = ["onClick"]
const _hoisted_130 = { key: 0 }
const _hoisted_131 = { class: "edit-info-banner" }
const _hoisted_132 = { class: "edit-section-title" }
const _hoisted_133 = { class: "drawer-form-row" }
const _hoisted_134 = { class: "drawer-form-group" }
const _hoisted_135 = { class: "drawer-label" }
const _hoisted_136 = { class: "drawer-form-group" }
const _hoisted_137 = { class: "drawer-label" }
const _hoisted_138 = { class: "drawer-form-group" }
const _hoisted_139 = { class: "drawer-label" }
const _hoisted_140 = { class: "drawer-form-row" }
const _hoisted_141 = { class: "drawer-form-group" }
const _hoisted_142 = { class: "drawer-label" }
const _hoisted_143 = { class: "drawer-form-group" }
const _hoisted_144 = { class: "drawer-label" }
const _hoisted_145 = { class: "drawer-form-group" }
const _hoisted_146 = { class: "drawer-label" }
const _hoisted_147 = ["placeholder"]
const _hoisted_148 = { class: "drawer-form-group" }
const _hoisted_149 = { class: "drawer-label" }
const _hoisted_150 = { class: "about-char-count" }
const _hoisted_151 = ["placeholder"]
const _hoisted_152 = { class: "edit-section-title" }
const _hoisted_153 = { class: "drawer-form-row" }
const _hoisted_154 = { class: "drawer-form-group" }
const _hoisted_155 = { class: "drawer-label" }
const _hoisted_156 = ["placeholder"]
const _hoisted_157 = { class: "drawer-form-group" }
const _hoisted_158 = { class: "drawer-label" }
const _hoisted_159 = { class: "drawer-form-group" }
const _hoisted_160 = { class: "drawer-label" }
const _hoisted_161 = { class: "drawer-form-row" }
const _hoisted_162 = { class: "drawer-form-group" }
const _hoisted_163 = { class: "drawer-label" }
const _hoisted_164 = ["placeholder"]
const _hoisted_165 = { class: "drawer-form-group" }
const _hoisted_166 = { class: "drawer-label" }
const _hoisted_167 = ["placeholder"]
const _hoisted_168 = { key: 1 }
const _hoisted_169 = {
  key: 0,
  class: "tab-content-section"
}
const _hoisted_170 = {
  key: 0,
  class: "tab-meta-row"
}
const _hoisted_171 = { class: "tab-meta-label" }
const _hoisted_172 = { class: "tab-meta-value" }
const _hoisted_173 = {
  key: 1,
  class: "tab-meta-row"
}
const _hoisted_174 = { class: "tab-meta-label" }
const _hoisted_175 = { class: "tab-meta-value" }
const _hoisted_176 = {
  key: 2,
  class: "tab-meta-row"
}
const _hoisted_177 = { class: "tab-meta-label" }
const _hoisted_178 = { class: "tab-meta-value" }
const _hoisted_179 = {
  key: 3,
  class: "tab-section"
}
const _hoisted_180 = { class: "edit-section-title" }
const _hoisted_181 = { class: "tab-kv-key" }
const _hoisted_182 = { class: "tab-kv-value" }
const _hoisted_183 = {
  key: 4,
  class: "tab-empty-message"
}
const _hoisted_184 = {
  key: 1,
  class: "tab-empty-message"
}
const _hoisted_185 = { key: 2 }
const _hoisted_186 = { class: "tab-content-section" }
const _hoisted_187 = { class: "edit-section-title" }
const _hoisted_188 = {
  key: 0,
  class: "tab-groups-grid"
}
const _hoisted_189 = ["checked", "onChange"]
const _hoisted_190 = {
  key: 1,
  class: "tab-empty-message"
}
const _hoisted_191 = { class: "btn btn-secondary btn-size-default margin-top-20" }
const _hoisted_192 = { key: 3 }
const _hoisted_193 = { class: "tab-content-section" }
const _hoisted_194 = { class: "edit-section-title" }
const _hoisted_195 = { key: 0 }
const _hoisted_196 = { class: "drawer-label tab-info-label" }
const _hoisted_197 = { class: "tab-info-input-wrap" }
const _hoisted_198 = ["onUpdate:modelValue", "disabled", "title"]
const _hoisted_199 = {
  key: 1,
  class: "tab-empty-message"
}
const _hoisted_200 = { key: 4 }
const _hoisted_201 = { class: "tab-content-section" }
const _hoisted_202 = { class: "edit-section-title" }
const _hoisted_203 = {
  key: 0,
  class: "checkin-table"
}
const _hoisted_204 = { class: "checkin-table-action" }
const _hoisted_205 = ["onClick"]
const _hoisted_206 = {
  key: 1,
  class: "tab-empty-message checkin-empty"
}
const _hoisted_207 = { class: "edit-section-title margin-top-20" }
const _hoisted_208 = {
  key: 2,
  class: "checkin-table"
}
const _hoisted_209 = {
  key: 3,
  class: "tab-empty-message checkin-empty"
}
const _hoisted_210 = { key: 5 }
const _hoisted_211 = { class: "tab-content-section" }
const _hoisted_212 = { class: "edit-section-title" }
const _hoisted_213 = ["placeholder"]
const _hoisted_214 = {
  key: 0,
  class: "tab-note-meta-row"
}
const _hoisted_215 = {
  key: 0,
  class: "tab-note-meta-item"
}
const _hoisted_216 = {
  key: 1,
  class: "tab-note-meta-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_SideDrawer = _resolveComponent("SideDrawer")!
  const _component_NewParticipantGrid = _resolveComponent("NewParticipantGrid")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_IdentityCard = _resolveComponent("IdentityCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_loading, {
      "show-loading": _ctx.isLoading,
      "border-color": _ctx.loaderBorderColor
    }, null, 8, ["show-loading", "border-color"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            type: "text",
            placeholder: _ctx.$t('Participant.SearchPlaceholder'),
            class: "form-control input-field participant-search-input",
            onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.OnSearchTermChange && _ctx.OnSearchTermChange(...args)), ["enter"]))
          }, null, 40, _hoisted_5), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[56] || (_cache[56] = _createElementVNode("i", { class: "fa fa-search participant-search-icon" }, null, -1)),
          _withDirectives(_createElementVNode("img", {
            src: _ctx.crossIcon,
            class: "clear-search-icon",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ClearSearch && _ctx.ClearSearch(...args)))
          }, null, 8, _hoisted_6), [
            [_vShow, _ctx.searchTerm !== '']
          ])
        ]),
        _createElementVNode("button", {
          class: "btn btn-secondary btn-size-header-main",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.OpenFilterDrawer && _ctx.OpenFilterDrawer(...args)))
        }, [
          (_ctx.activeFilterCount == 0)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.filterIcon,
                class: "menu-item-icon",
                alt: "filter"
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.activeFilterCount > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.activeFilterCount), 1))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.Filters')), 1)
        ]),
        _createElementVNode("img", {
          src: _ctx.custmiseColumn,
          class: "menu-item-icon cursor-pointer",
          alt: "customize columns",
          title: _ctx.$t('Participant.CustomizeColumns'),
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.OpenColumnDrawer && _ctx.OpenColumnDrawer(...args)))
        }, null, 8, _hoisted_9),
        (_ctx.activeFilterCount > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('Participant.ShowingParticipants', { count: _ctx.totalCount })), 1),
              _createElementVNode("a", {
                href: "javascript:void(0)",
                class: "filter-summary-clear-link",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.ClearAppliedFilters && _ctx.ClearAppliedFilters(...args)))
              }, _toDisplayString(_ctx.$t('Participant.ClearFilters')), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_SideDrawer, {
          "show-drawer": _ctx.showFilterPanel,
          title: _ctx.$t('Participant.Filters'),
          "confirm-button-text": _ctx.$t('Participant.Apply'),
          onClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showFilterPanel = false)),
          onCancel: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showFilterPanel = false)),
          onConfirm: _ctx.ApplyFilters
        }, {
          "footer-left": _withCtx(() => [
            _createElementVNode("a", {
              href: "javascript:void(0)",
              class: "clear-filters-link",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.ClearDraftFilters && _ctx.ClearDraftFilters(...args)))
            }, _toDisplayString(_ctx.$t('Participant.ClearFilters')), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('Participant.FilterByName')), 1),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.draftNameFilter) = $event)),
                    type: "radio",
                    value: "all"
                  }, null, 512), [
                    [_vModelRadio, _ctx.draftNameFilter]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.FilterByName.All')), 1)
                ]),
                _createElementVNode("label", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.draftNameFilter) = $event)),
                    type: "radio",
                    value: "withoutName"
                  }, null, 512), [
                    [_vModelRadio, _ctx.draftNameFilter]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.FilterByName.WithoutName')), 1)
                ]),
                _createElementVNode("label", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.draftNameFilter) = $event)),
                    type: "radio",
                    value: "withName"
                  }, null, 512), [
                    [_vModelRadio, _ctx.draftNameFilter]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.FilterByName.WithName')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('Participant.FilterByCheckIn')), 1),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.draftCheckInFilter) = $event)),
                    type: "radio",
                    value: "all"
                  }, null, 512), [
                    [_vModelRadio, _ctx.draftCheckInFilter]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.FilterByCheckIn.All')), 1)
                ]),
                _createElementVNode("label", _hoisted_22, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.draftCheckInFilter) = $event)),
                    type: "radio",
                    value: "checkedIn"
                  }, null, 512), [
                    [_vModelRadio, _ctx.draftCheckInFilter]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.FilterByCheckIn.CheckedIn')), 1)
                ]),
                _createElementVNode("label", _hoisted_23, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.draftCheckInFilter) = $event)),
                    type: "radio",
                    value: "notCheckedIn"
                  }, null, 512), [
                    [_vModelRadio, _ctx.draftCheckInFilter]
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.FilterByCheckIn.NotCheckedIn')), 1)
                ])
              ])
            ]),
            (_ctx.enableRegistrationSystem)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('Participant.FilterStatus')), 1),
                  _createElementVNode("div", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableStatuses, (s) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: s,
                        class: "filter-item"
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: _ctx.draftStatuses.includes(s),
                          onChange: ($event: any) => (_ctx.ToggleStatusFilter(s))
                        }, null, 40, _hoisted_27),
                        _createTextVNode(" " + _toDisplayString(s), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.enableRegistrationSystem)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('Participant.FilterEmailStatus')), 1),
                  _createElementVNode("div", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableEmailStatuses, (e) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: e,
                        class: "filter-item"
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: _ctx.draftEmailStatuses.includes(e),
                          onChange: ($event: any) => (_ctx.ToggleEmailStatusFilter(e))
                        }, null, 40, _hoisted_31),
                        _createTextVNode(" " + _toDisplayString(e), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.availableTicketTypes.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('Participant.FilterTicketType')), 1),
                  _createElementVNode("div", _hoisted_34, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTicketTypes, (t) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: t.Name,
                        class: "filter-item"
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: _ctx.draftTicketTypes.includes(t.Name),
                          onChange: ($event: any) => (_ctx.ToggleTicketTypeFilter(t.Name))
                        }, null, 40, _hoisted_35),
                        _createTextVNode(" " + _toDisplayString(t.Name), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.allGroups.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('Participant.FilterByGroup')), 1),
                  _createElementVNode("div", _hoisted_38, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allGroups, (g) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: g.Id,
                        class: "filter-item"
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: _ctx.draftGroupIds.includes(g.Id),
                          onChange: ($event: any) => (_ctx.ToggleGroupFilter(g.Id))
                        }, null, 40, _hoisted_39),
                        _createTextVNode(" " + _toDisplayString(g.Name), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('Participant.FilterByNote')), 1),
              _createElementVNode("label", _hoisted_42, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.draftHasNote) = $event)),
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.draftHasNote]
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.FilterByNote.HasAdminNote')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["show-drawer", "title", "confirm-button-text", "onConfirm"]),
        _createVNode(_component_SideDrawer, {
          "show-drawer": _ctx.showColumnChooser,
          title: _ctx.$t('Participant.CustomizeColumns'),
          subtitle: _ctx.$t('Participant.CustomizeColumnsDesc'),
          onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showColumnChooser = false)),
          onCancel: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showColumnChooser = false)),
          onConfirm: _ctx.SaveColumns
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allColumnGroups, (group) => {
              return (_openBlock(), _createElementBlock("div", {
                key: group.title,
                class: "chooser-group"
              }, [
                _createElementVNode("div", _hoisted_43, _toDisplayString(group.title), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.fields, (col) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: col.field,
                    class: "chooser-item"
                  }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: _ctx.draftColumnVisibility[col.field] !== false,
                      onChange: ($event: any) => (_ctx.ToggleDraftColumn(col.field))
                    }, null, 40, _hoisted_44),
                    _createTextVNode(" " + _toDisplayString(col.title), 1)
                  ]))
                }), 128))
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["show-drawer", "title", "subtitle", "onConfirm"])
      ]),
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("button", {
          class: "btn btn-secondary btn-size-header-main",
          onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.OpenImportDrawer && _ctx.OpenImportDrawer(...args)))
        }, [
          _createElementVNode("img", {
            src: _ctx.importIcon,
            class: "menu-item-icon",
            alt: "import"
          }, null, 8, _hoisted_46),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.Import')), 1)
        ]),
        _createElementVNode("button", {
          class: "btn btn-secondary btn-size-header-main",
          onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.OpenExportDrawer && _ctx.OpenExportDrawer(...args)))
        }, [
          _createElementVNode("img", {
            src: _ctx.exportIcon,
            class: "menu-item-icon",
            alt: "export"
          }, null, 8, _hoisted_47),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.Export')), 1)
        ]),
        _createElementVNode("button", {
          class: "btn btn-secondary btn-size-header-main",
          onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.OpenSendEmailDrawer && _ctx.OpenSendEmailDrawer(...args)))
        }, [
          _createElementVNode("img", {
            src: _ctx.emailIcon,
            class: "menu-item-icon",
            alt: "send emails"
          }, null, 8, _hoisted_48),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.SendEmails')), 1)
        ])
      ])
    ]),
    _createVNode(_component_NewParticipantGrid, {
      rows: _ctx.participants,
      "all-groups": _ctx.allGroups,
      "all-extra-informations": _ctx.allExtraInformations,
      "column-visibility": _ctx.effectiveColumnVisibility,
      "total-count": _ctx.totalCount,
      "server-skip": _ctx.skip,
      "server-page-size": _ctx.pageSize,
      "is-all-pages-selected": _ctx.isAllPagesSelected,
      onRowAction: _ctx.OnRowAction,
      onSortChange: _ctx.OnSortChange,
      onPageChange: _ctx.OnPageChange,
      onSelectionChange: _ctx.OnSelectionChange,
      onSelectAll: _ctx.OnSelectAll,
      onClearSelectAll: _ctx.OnClearSelectAll,
      onBulkAction: _ctx.OnBulkAction,
      onImportClick: _ctx.OpenImportDrawer,
      onRowClicked: _ctx.OpenEditDrawer
    }, null, 8, ["rows", "all-groups", "all-extra-informations", "column-visibility", "total-count", "server-skip", "server-page-size", "is-all-pages-selected", "onRowAction", "onSortChange", "onPageChange", "onSelectionChange", "onSelectAll", "onClearSelectAll", "onBulkAction", "onImportClick", "onRowClicked"]),
    _createVNode(_component_SideDrawer, {
      "show-drawer": _ctx.showImportDrawer,
      title: _ctx.$t('Participant.Import.DrawerTitle'),
      "confirm-button-text": _ctx.$t('Participant.Import.ImportButton'),
      "confirm-disabled": !_ctx.importFile,
      onClose: _ctx.CloseImportDrawer,
      onCancel: _ctx.CloseImportDrawer,
      onConfirm: _ctx.ConfirmImport
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t('Participant.Import.Subtitle')), 1),
        _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t('Participant.Import.BeforeUpload')), 1),
        _createElementVNode("ul", _hoisted_51, [
          _createElementVNode("li", null, [
            _createTextVNode(_toDisplayString(_ctx.$t('Participant.Import.UseTemplate')) + " ", 1),
            _createElementVNode("a", _hoisted_52, _toDisplayString(_ctx.$t('Participant.Import.ExcelTemplate')), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('Participant.Import.EmailRequired')), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.Import.EmailRequiredDesc')) + " ", 1),
            _createElementVNode("ul", _hoisted_53, [
              _createElementVNode("li", null, _toDisplayString(_ctx.$t('Participant.Import.NoMissing')), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.$t('Participant.Import.NoDuplicates')), 1)
            ])
          ]),
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('Participant.Import.OnlyXlsx', {maxImportLimit: _ctx.maxImportLimit})), 1),
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('Participant.Import.SemicolonGroups')), 1),
          _createElementVNode("li", null, _toDisplayString(_ctx.$t('Participant.Import.OverwriteExisting')), 1)
        ]),
        _cache[59] || (_cache[59] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createTextVNode(_toDisplayString(_ctx.$t('Participant.Import.CustomFieldsTitle')) + " ", 1),
            _createElementVNode("span", null, [
              _createElementVNode("i", {
                class: "fa fa-info-circle overlay-info",
                "aria-hidden": "true",
                onMouseover: _cache[21] || (_cache[21] = ($event: any) => (_ctx.importTooltipVisible = true)),
                onMouseleave: _cache[22] || (_cache[22] = ($event: any) => (_ctx.importTooltipVisible = false))
              }, null, 32),
              _withDirectives(_createElementVNode("div", { class: "information-icon-div" }, _toDisplayString(_ctx.$t('Participant.Import.CustomFieldsTooltip')), 513), [
                [_vShow, _ctx.importTooltipVisible]
              ])
            ])
          ]),
          _createElementVNode("ul", _hoisted_56, [
            _createElementVNode("li", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('Participant.Import.CustomFieldsCreate')) + " ", 1),
              _createVNode(_component_router_link, {
                to: { name: 'myinformation' },
                class: "import-myinfo-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Participant.Import.MyInformation')) + " ", 1),
                  _cache[57] || (_cache[57] = _createElementVNode("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }),
                    _createElementVNode("polyline", { points: "15 3 21 3 21 9" }),
                    _createElementVNode("line", {
                      x1: "10",
                      y1: "14",
                      x2: "21",
                      y2: "3"
                    })
                  ], -1))
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.Import.BeforeImporting')), 1)
            ]),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t('Participant.Import.CustomFieldsHint2')), 1)
          ])
        ]),
        _createElementVNode("input", {
          ref: "importFileInput",
          type: "file",
          accept: ".xlsx",
          class: "hidden-file-input",
          onChange: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.OnImportFileSelected && _ctx.OnImportFileSelected(...args)))
        }, null, 544),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary btn-size-default",
          onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.TriggerImportFileInput && _ctx.TriggerImportFileInput(...args)))
        }, [
          _cache[58] || (_cache[58] = _createElementVNode("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            class: "margin-right-5"
          }, [
            _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
            _createElementVNode("polyline", { points: "17 8 12 3 7 8" }),
            _createElementVNode("line", {
              x1: "12",
              y1: "3",
              x2: "12",
              y2: "15"
            })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.importFile ? _ctx.importFile.name : _ctx.$t('Participant.Import.UploadFile')), 1)
        ]),
        (_ctx.showImportExcelError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
              _createElementVNode("img", { src: _ctx.alertCrossIcon }, null, 8, _hoisted_58),
              _createTextVNode(" " + _toDisplayString(_ctx.validationErrorMesssage), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show-drawer", "title", "confirm-button-text", "confirm-disabled", "onClose", "onCancel", "onConfirm"]),
    _createVNode(_component_SideDrawer, {
      "show-drawer": _ctx.showImportedParticipantsTable,
      title: _ctx.$t('Participant.Import.DrawerTitle'),
      "confirm-button-text": _ctx.$t('Participant.Import.ImportButton'),
      "confirm-disabled": !_ctx.importExcelFile,
      width: _ctx.importedParticipantsTablesScreenWidth,
      onClose: _ctx.CloseImportParticipantsToExcel,
      onCancel: _ctx.CloseImportParticipantsToExcel,
      onConfirm: _ctx.ConfirmImportParticipantsToExcel
    }, {
      default: _withCtx(() => [
        (!_ctx.showImportSuccessfullScreen && !_ctx.showExcelValidationsErrors)
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              (_ctx.showExtraColumnsWarning)
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _createElementVNode("img", { src: _ctx.alertTraingleIcon }, null, 8, _hoisted_61),
                    _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.extraColumnsWarningMessage), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showTotalParticipantsImportedInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("img", { src: _ctx.infoIcon }, null, 8, _hoisted_64),
                    _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.totalParticipantsImportedMessage), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showImportExcelMaxRowsError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                    _createElementVNode("img", { src: _ctx.alertCrossIcon }, null, 8, _hoisted_67),
                    _createTextVNode(" " + _toDisplayString(_ctx.validationErrorMesssage), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("table", _hoisted_69, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.excelHeaders, (header, index) => {
                        return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(header), 1))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.excelRows.slice(0, 3), (row, rowIndex) => {
                      return (_openBlock(), _createElementBlock("tr", { key: rowIndex }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, colIndex) => {
                          return (_openBlock(), _createElementBlock("td", { key: colIndex }, _toDisplayString(cell), 1))
                        }), 128))
                      ]))
                    }), 128)),
                    (_ctx.excelRows.length > 3)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_70, [
                          _createElementVNode("td", {
                            colspan: _ctx.excelHeaders.length,
                            class: "table-counts-row"
                          }, _toDisplayString(_ctx.GetTotalParticipantsCountText(_ctx.excelRows.length - 3, 'Participant.Import.TableCount')), 9, _hoisted_71)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : (_ctx.showExcelValidationsErrors)
            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                _createElementVNode("table", _hoisted_73, [
                  _cache[60] || (_cache[60] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Row no."),
                      _createElementVNode("th", null, "Email"),
                      _createElementVNode("th", null, "Error")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importValidationErrors, (error, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(error.RowNo), 1),
                        _createElementVNode("td", null, _toDisplayString(error.Email || '-'), 1),
                        _createElementVNode("td", null, _toDisplayString(error.Error), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", { src: _ctx.successIcon }, null, 8, _hoisted_76)
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.$t('Participant.Import.ImportComplete')), 1),
                    _createElementVNode("label", null, _toDisplayString(_ctx.GetTotalParticipantsCountText(_ctx.totalExcelRowsCount, 'Participant.Import.NumberedParticipantsImportedSuccessfully')), 1)
                  ])
                ])
              ]))
      ]),
      _: 1
    }, 8, ["show-drawer", "title", "confirm-button-text", "confirm-disabled", "width", "onClose", "onCancel", "onConfirm"]),
    _createVNode(_component_SideDrawer, {
      "show-drawer": _ctx.showExportDrawer,
      title: _ctx.$t('Participant.Export.DrawerTitle'),
      "confirm-button-text": _ctx.$t('Participant.Export.ExportButton', { count: _ctx.ExportCount }),
      onClose: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showExportDrawer = false)),
      onCancel: _cache[29] || (_cache[29] = ($event: any) => (_ctx.showExportDrawer = false)),
      onConfirm: _ctx.ConfirmExport
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_79, _toDisplayString(_ctx.$t('Participant.Export.Subtitle')), 1),
        _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.$t('Participant.Export.SelectAttendees')), 1),
        _createElementVNode("label", _hoisted_81, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.exportScope) = $event)),
            type: "radio",
            name: "exportScope",
            value: "all"
          }, null, 512), [
            [_vModelRadio, _ctx.exportScope]
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.Export.AllAttendees', { count: _ctx.totalCount })), 1)
        ]),
        _createElementVNode("label", {
          class: _normalizeClass(["export-radio", { 'export-radio--disabled': _ctx.activeFilterCount === 0 }])
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.exportScope) = $event)),
            type: "radio",
            name: "exportScope",
            value: "filtered",
            disabled: _ctx.activeFilterCount === 0
          }, null, 8, _hoisted_82), [
            [_vModelRadio, _ctx.exportScope]
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.Export.FilteredAttendees', { count: _ctx.totalCount })), 1)
        ], 2),
        _createElementVNode("label", {
          class: _normalizeClass(["export-radio", { 'export-radio--disabled': _ctx.selectedCount === 0 }])
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.exportScope) = $event)),
            type: "radio",
            name: "exportScope",
            value: "selected",
            disabled: _ctx.selectedCount === 0
          }, null, 8, _hoisted_83), [
            [_vModelRadio, _ctx.exportScope]
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.Export.SelectedAttendees', { count: _ctx.selectedCount })), 1)
        ], 2),
        _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.$t('Participant.Export.WhatToExport')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exportCategories, (cat) => {
          return (_openBlock(), _createElementBlock("div", {
            key: cat.id,
            class: "export-category"
          }, [
            _createElementVNode("label", {
              class: _normalizeClass(["export-checkbox", { 'export-checkbox--disabled': cat.disabled }])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((cat.checked) = $event),
                type: "checkbox",
                disabled: cat.disabled
              }, null, 8, _hoisted_85), [
                [_vModelCheckbox, cat.checked]
              ]),
              _createTextVNode(" " + _toDisplayString(cat.label), 1)
            ], 2),
            (cat.children && cat.children.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cat.children, (child) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: child.id,
                      class: _normalizeClass(["export-checkbox", { 'export-checkbox--disabled': child.disabled }])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((child.checked) = $event),
                        type: "checkbox",
                        disabled: child.disabled
                      }, null, 8, _hoisted_87), [
                        [_vModelCheckbox, child.checked]
                      ]),
                      _createTextVNode(" " + _toDisplayString(child.label), 1)
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["show-drawer", "title", "confirm-button-text", "onConfirm"]),
    _createVNode(_component_SideDrawer, {
      "show-drawer": _ctx.showSendEmailDrawer,
      title: _ctx.$t('Participant.Email.DrawerTitle'),
      subtitle: _ctx.$t('Participant.Email.DrawerSubtitle'),
      "confirm-button-text": _ctx.$t('Participant.Email.SendButton', { count: _ctx.isBulkEmailContext ? _ctx.selectedCount : _ctx.totalCount }),
      onClose: _cache[31] || (_cache[31] = ($event: any) => {_ctx.showSendEmailDrawer = false; _ctx.isBulkEmailContext = false}),
      onCancel: _cache[32] || (_cache[32] = ($event: any) => {_ctx.showSendEmailDrawer = false; _ctx.isBulkEmailContext = false}),
      onConfirm: _ctx.ConfirmSendEmail
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailTypes, (emailType) => {
          return (_openBlock(), _createElementBlock("div", {
            key: emailType.id,
            class: _normalizeClass(["email-type-card", { 'email-type-card--selected': _ctx.selectedEmailType === emailType.id }]),
            onClick: ($event: any) => (_ctx.selectedEmailType = emailType.id)
          }, [
            _createElementVNode("label", _hoisted_89, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.selectedEmailType) = $event)),
                type: "radio",
                name: "emailType",
                value: emailType.id
              }, null, 8, _hoisted_90), [
                [_vModelRadio, _ctx.selectedEmailType]
              ]),
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("div", _hoisted_92, _toDisplayString(emailType.label), 1),
                _createElementVNode("div", _hoisted_93, _toDisplayString(emailType.description), 1),
                (emailType.lastSent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, " ⏱ " + _toDisplayString(_ctx.$t('Participant.Email.LastSent')) + ": " + _toDisplayString(emailType.lastSent), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 10, _hoisted_88))
        }), 128)),
        _createElementVNode("div", _hoisted_95, [
          _cache[61] || (_cache[61] = _createElementVNode("span", { class: "position-relative" }, [
            _createElementVNode("i", {
              class: "fa fa-info-circle overlay-info",
              "aria-hidden": "true"
            })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.Email.ViewTemplates')) + " ", 1),
          _createVNode(_component_router_link, {
            to: { name: 'invite' },
            class: "email-here-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Participant.Email.Here')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show-drawer", "title", "subtitle", "confirm-button-text", "onConfirm"]),
    _createVNode(_component_SideDrawer, {
      "show-drawer": _ctx.showAssignTicketDrawer,
      title: "Assign tickets",
      subtitle: "Select ticket(s) to assign",
      "confirm-button-text": _ctx.$t('Participant.Grid.AssignTicket').toString(),
      "confirm-disabled": _ctx.selectedAssignTicketIds.length === 0,
      onClose: _cache[33] || (_cache[33] = ($event: any) => (_ctx.showAssignTicketDrawer = false)),
      onCancel: _cache[34] || (_cache[34] = ($event: any) => (_ctx.showAssignTicketDrawer = false)),
      onConfirm: _ctx.ConfirmAssignTickets
    }, {
      default: _withCtx(() => [
        (_ctx.paidAssignTickets.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
              _cache[62] || (_cache[62] = _createElementVNode("div", { class: "assign-ticket-section-title" }, " Stripe tickets (Paid) ", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paidAssignTickets, (ticket) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: ticket.Id,
                  class: "assign-ticket-item"
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: _ctx.selectedAssignTicketIds.includes(ticket.Id),
                    onChange: ($event: any) => (_ctx.ToggleAssignTicket(ticket.Id))
                  }, null, 40, _hoisted_97),
                  _createElementVNode("span", _hoisted_98, _toDisplayString(ticket.Name) + " (" + _toDisplayString(_ctx.GetTicketAvailabilityText(ticket)) + ") ", 1),
                  _createElementVNode("span", _hoisted_99, _toDisplayString(_ctx.FormatTicketPrice(ticket)), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.freeAssignTickets.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
              _cache[63] || (_cache[63] = _createElementVNode("div", { class: "assign-ticket-section-title" }, " Admin assigned tickets (Free tickets) ", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.freeAssignTickets, (ticket) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: ticket.Id,
                  class: "assign-ticket-item"
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: _ctx.selectedAssignTicketIds.includes(ticket.Id),
                    onChange: ($event: any) => (_ctx.ToggleAssignTicket(ticket.Id))
                  }, null, 40, _hoisted_101),
                  _createElementVNode("span", _hoisted_102, _toDisplayString(ticket.Name) + " (" + _toDisplayString(_ctx.GetTicketAvailabilityText(ticket)) + ") ", 1),
                  _createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.FormatTicketPrice(ticket)), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show-drawer", "confirm-button-text", "confirm-disabled", "onConfirm"]),
    _createVNode(_component_SideDrawer, {
      "show-drawer": _ctx.showRevokeTicketDrawer,
      title: "Revoke tickets",
      subtitle: "Select ticket(s) to revoke",
      "confirm-button-text": "Revoke",
      "confirm-disabled": _ctx.selectedRevokeTicketIds.length === 0,
      onClose: _cache[35] || (_cache[35] = ($event: any) => (_ctx.showRevokeTicketDrawer = false)),
      onCancel: _cache[36] || (_cache[36] = ($event: any) => (_ctx.showRevokeTicketDrawer = false)),
      onConfirm: _ctx.ConfirmRevokeTickets
    }, {
      default: _withCtx(() => [
        (_ctx.paidAssignTickets.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
              _cache[64] || (_cache[64] = _createElementVNode("div", { class: "assign-ticket-section-title" }, " Stripe tickets (Paid) ", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paidAssignTickets, (ticket) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: ticket.Id,
                  class: "assign-ticket-item"
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: _ctx.selectedRevokeTicketIds.includes(ticket.Id),
                    onChange: ($event: any) => (_ctx.ToggleRevokeTicket(ticket.Id))
                  }, null, 40, _hoisted_105),
                  _createElementVNode("span", _hoisted_106, _toDisplayString(ticket.Name) + " (" + _toDisplayString(_ctx.GetTicketAvailabilityText(ticket)) + ") ", 1),
                  _createElementVNode("span", _hoisted_107, _toDisplayString(_ctx.FormatTicketPrice(ticket)), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.freeAssignTickets.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
              _cache[65] || (_cache[65] = _createElementVNode("div", { class: "assign-ticket-section-title" }, " Admin assigned tickets (Free tickets) ", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.freeAssignTickets, (ticket) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: ticket.Id,
                  class: "assign-ticket-item"
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: _ctx.selectedRevokeTicketIds.includes(ticket.Id),
                    onChange: ($event: any) => (_ctx.ToggleRevokeTicket(ticket.Id))
                  }, null, 40, _hoisted_109),
                  _createElementVNode("span", _hoisted_110, _toDisplayString(ticket.Name) + " (" + _toDisplayString(_ctx.GetTicketAvailabilityText(ticket)) + ") ", 1),
                  _createElementVNode("span", _hoisted_111, _toDisplayString(_ctx.FormatTicketPrice(ticket)), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show-drawer", "confirm-disabled", "onConfirm"]),
    _createVNode(_component_SideDrawer, {
      "show-drawer": _ctx.showAssignGroupDrawer,
      title: "Assign to group",
      "confirm-button-text": _ctx.$t('Participant.Grid.AssignToGroup').toString(),
      "confirm-disabled": _ctx.isAssignGroupConfirmDisabled,
      onClose: _ctx.CloseAssignGroupDrawer,
      onCancel: _ctx.CloseAssignGroupDrawer,
      onConfirm: _ctx.ConfirmAssignGroup
    }, {
      default: _withCtx(() => [
        _createElementVNode("label", _hoisted_112, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.assignGroupMode) = $event)),
            type: "radio",
            name: "assignGroupMode",
            value: "existing"
          }, null, 512), [
            [_vModelRadio, _ctx.assignGroupMode]
          ]),
          _cache[66] || (_cache[66] = _createElementVNode("span", null, "Select an existing group", -1))
        ]),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.selectedAssignGroupId) = $event)),
          class: "form-control assign-group-select",
          disabled: _ctx.assignGroupMode !== 'existing'
        }, [
          _cache[67] || (_cache[67] = _createElementVNode("option", { value: null }, " Select group ", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allGroups, (group) => {
            return (_openBlock(), _createElementBlock("option", {
              key: group.Id,
              value: group.Id
            }, _toDisplayString(group.Name), 9, _hoisted_114))
          }), 128))
        ], 8, _hoisted_113), [
          [_vModelSelect, _ctx.selectedAssignGroupId]
        ]),
        _createElementVNode("label", _hoisted_115, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.assignGroupMode) = $event)),
            type: "radio",
            name: "assignGroupMode",
            value: "new"
          }, null, 512), [
            [_vModelRadio, _ctx.assignGroupMode]
          ]),
          _cache[68] || (_cache[68] = _createElementVNode("span", null, "Create new group to assign", -1))
        ]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.newAssignGroupName) = $event)),
          type: "text",
          class: "form-control assign-group-input",
          disabled: _ctx.assignGroupMode !== 'new'
        }, null, 8, _hoisted_116), [
          [
            _vModelText,
            _ctx.newAssignGroupName,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _: 1
    }, 8, ["show-drawer", "confirm-button-text", "confirm-disabled", "onClose", "onCancel", "onConfirm"]),
    _createVNode(_component_SideDrawer, {
      "show-drawer": _ctx.showEditDrawer,
      width: "65%",
      onClose: _cache[54] || (_cache[54] = ($event: any) => (_ctx.showEditDrawer = false)),
      onCancel: _cache[55] || (_cache[55] = ($event: any) => (_ctx.showEditDrawer = false)),
      onConfirm: _ctx.ConfirmEditParticipant
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_117, [
          _createVNode(_component_IdentityCard, {
            size: 80,
            "first-name": _ctx.editForm.FirstName,
            "last-name": _ctx.editForm.LastName,
            "image-url": _ctx.editForm.IconUrl
          }, null, 8, ["first-name", "last-name", "image-url"]),
          _createElementVNode("div", _hoisted_118, [
            _createElementVNode("div", _hoisted_119, _toDisplayString(_ctx.editForm.FirstName) + " " + _toDisplayString(_ctx.editForm.LastName), 1),
            _createElementVNode("div", _hoisted_120, [
              _createTextVNode(_toDisplayString(_ctx.editForm.Title), 1),
              (_ctx.editForm.Title && _ctx.editForm.Company)
                ? (_openBlock(), _createElementBlock("span", _hoisted_121, " | "))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(_ctx.editForm.Company), 1)
            ]),
            _createElementVNode("div", _hoisted_122, _toDisplayString(_ctx.editForm.Email), 1),
            _createElementVNode("div", _hoisted_123, [
              ((_ctx.editForm.RegistrationStatus || '').toLowerCase() === 'attending')
                ? (_openBlock(), _createElementBlock("span", _hoisted_124, _toDisplayString(_ctx.$t('Participant.Attending')), 1))
                : ((_ctx.editForm.RegistrationStatus || '').toLowerCase() === 'invited')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_125, _toDisplayString(_ctx.$t('Participant.Invited')), 1))
                  : ((_ctx.editForm.RegistrationStatus || '').toLowerCase() === 'not attending')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_126, _toDisplayString(_ctx.$t('Participant.NotAttending')), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_127, _toDisplayString(_ctx.editForm.RegistrationStatus), 1)),
              _createElementVNode("span", {
                class: _normalizeClass(["badge", [_ctx.editForm.IsLoggedInApp ? 'badge-green' : 'badge-red']])
              }, _toDisplayString((_ctx.editForm.IsLoggedInApp)
                  ? _ctx.$t('Participant.Edit.AppInstalled')
                  : _ctx.$t('Participant.Edit.AppNotInstalled')), 3)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_128, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editTabs, (tab) => {
            return (_openBlock(), _createElementBlock("button", {
              key: tab.id,
              class: _normalizeClass(["edit-tab", { 'edit-tab--active': _ctx.activeEditTab === tab.id }]),
              onClick: ($event: any) => (_ctx.activeEditTab = tab.id)
            }, _toDisplayString(tab.label), 11, _hoisted_129))
          }), 128))
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.activeEditTab === 'profile')
          ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
              _createElementVNode("div", _hoisted_131, [
                _cache[69] || (_cache[69] = _createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.Edit.CrossEventNotice')), 1)
              ]),
              _createElementVNode("div", _hoisted_132, _toDisplayString(_ctx.$t('Participant.Edit.ProfileDetails')), 1),
              _createElementVNode("div", _hoisted_133, [
                _createElementVNode("div", _hoisted_134, [
                  _createElementVNode("label", _hoisted_135, _toDisplayString(_ctx.$t('Participant.Add.FirstName')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.editForm.FirstName) = $event)),
                    type: "text",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.editForm.FirstName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_136, [
                  _createElementVNode("label", _hoisted_137, _toDisplayString(_ctx.$t('Participant.Add.LastName')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.editForm.LastName) = $event)),
                    type: "text",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.editForm.LastName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_138, [
                  _createElementVNode("label", _hoisted_139, [
                    _createTextVNode(_toDisplayString(_ctx.$t('Participant.Add.Email')), 1),
                    _cache[70] || (_cache[70] = _createElementVNode("span", { class: "required-star" }, "*", -1))
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.editForm.Email) = $event)),
                    type: "email",
                    class: "form-control",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.editForm.Email]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_140, [
                _createElementVNode("div", _hoisted_141, [
                  _createElementVNode("label", _hoisted_142, _toDisplayString(_ctx.$t('Participant.Add.Company')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.editForm.Company) = $event)),
                    type: "text",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.editForm.Company]
                  ])
                ]),
                _createElementVNode("div", _hoisted_143, [
                  _createElementVNode("label", _hoisted_144, _toDisplayString(_ctx.$t('Participant.Edit.JobTitle')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.editForm.Title) = $event)),
                    type: "text",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.editForm.Title]
                  ])
                ]),
                _createElementVNode("div", _hoisted_145, [
                  _createElementVNode("label", _hoisted_146, _toDisplayString(_ctx.$t('Participant.Add.Phone')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.editForm.Phone) = $event)),
                    type: "tel",
                    class: "form-control",
                    placeholder: _ctx.$t('Participant.Add.PhonePlaceholder')
                  }, null, 8, _hoisted_147), [
                    [_vModelText, _ctx.editForm.Phone]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_148, [
                _createElementVNode("label", _hoisted_149, [
                  _createTextVNode(_toDisplayString(_ctx.$t('Participant.Add.About')) + " ", 1),
                  _createElementVNode("span", _hoisted_150, _toDisplayString(_ctx.editForm.About.length) + "/500", 1)
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.editForm.About) = $event)),
                  class: "form-control",
                  rows: "3",
                  maxlength: "500",
                  placeholder: _ctx.$t('Participant.Add.AboutPlaceholder')
                }, null, 8, _hoisted_151), [
                  [_vModelText, _ctx.editForm.About]
                ])
              ]),
              _createElementVNode("div", _hoisted_152, _toDisplayString(_ctx.$t('Participant.Edit.Social')), 1),
              _createElementVNode("div", _hoisted_153, [
                _createElementVNode("div", _hoisted_154, [
                  _createElementVNode("label", _hoisted_155, _toDisplayString(_ctx.$t('Participant.Edit.WebsiteUrl')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.editForm.Website) = $event)),
                    type: "url",
                    class: "form-control",
                    placeholder: _ctx.$t('Participant.Add.WebsitePlaceholder')
                  }, null, 8, _hoisted_156), [
                    [_vModelText, _ctx.editForm.Website]
                  ])
                ]),
                _createElementVNode("div", _hoisted_157, [
                  _createElementVNode("label", _hoisted_158, _toDisplayString(_ctx.$t('Participant.Edit.InstagramHandle')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.editForm.Instagram) = $event)),
                    type: "text",
                    class: "form-control",
                    placeholder: "username"
                  }, null, 512), [
                    [_vModelText, _ctx.editForm.Instagram]
                  ])
                ]),
                _createElementVNode("div", _hoisted_159, [
                  _createElementVNode("label", _hoisted_160, _toDisplayString(_ctx.$t('Participant.Add.XHandle')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.editForm.TwitterHandle) = $event)),
                    type: "text",
                    class: "form-control",
                    placeholder: "username"
                  }, null, 512), [
                    [_vModelText, _ctx.editForm.TwitterHandle]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_161, [
                _createElementVNode("div", _hoisted_162, [
                  _createElementVNode("label", _hoisted_163, _toDisplayString(_ctx.$t('Participant.Edit.FacebookProfile')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.editForm.FacebookProfileId) = $event)),
                    type: "text",
                    class: "form-control",
                    placeholder: _ctx.$t('Participant.Edit.FacebookPlaceholder')
                  }, null, 8, _hoisted_164), [
                    [_vModelText, _ctx.editForm.FacebookProfileId]
                  ])
                ]),
                _createElementVNode("div", _hoisted_165, [
                  _createElementVNode("label", _hoisted_166, _toDisplayString(_ctx.$t('Participant.Edit.LinkedInProfile')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.editForm.LinkedInPublicProfileUrl) = $event)),
                    type: "url",
                    class: "form-control",
                    placeholder: _ctx.$t('Participant.Edit.LinkedInPlaceholder')
                  }, null, 8, _hoisted_167), [
                    [_vModelText, _ctx.editForm.LinkedInPublicProfileUrl]
                  ])
                ])
              ])
            ]))
          : (_ctx.activeEditTab === 'registration')
            ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                (_ctx.editForm.Registration)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                      (_ctx.editForm.Registration.AddedOn)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                            _createElementVNode("span", _hoisted_171, _toDisplayString(_ctx.$t('Participant.Edit.RegisteredOn')), 1),
                            _createElementVNode("span", _hoisted_172, _toDisplayString(_ctx.editForm.Registration.AddedOn), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.editForm.Registration.OverallInviteeStatus)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_173, [
                            _createElementVNode("span", _hoisted_174, _toDisplayString(_ctx.$t('Participant.Edit.RegistrationStatus')), 1),
                            _createElementVNode("span", _hoisted_175, _toDisplayString(_ctx.editForm.Registration.OverallInviteeStatus), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.editForm.Registration.InviteeCategory)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                            _createElementVNode("span", _hoisted_177, _toDisplayString(_ctx.$t('Participant.Edit.InviteeCategory')), 1),
                            _createElementVNode("span", _hoisted_178, _toDisplayString(_ctx.editForm.Registration.InviteeCategory), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.editForm.Registration.FormResponses && _ctx.editForm.Registration.FormResponses.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                            _createElementVNode("div", _hoisted_180, _toDisplayString(_ctx.$t('Participant.Edit.RegistrationAnswers')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editForm.Registration.FormResponses, (answer, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: idx,
                                class: "tab-kv-row"
                              }, [
                                _createElementVNode("span", _hoisted_181, _toDisplayString(answer.QuestionTitle), 1),
                                _createElementVNode("span", _hoisted_182, _toDisplayString(answer.Response || '-'), 1)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.editForm.Registration.FormResponses || !_ctx.editForm.Registration.FormResponses.length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_183, _toDisplayString(_ctx.$t('Participant.Edit.NoRegistrationAnswers')), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_184, _toDisplayString(_ctx.$t('Participant.Edit.NoRegistrationData')), 1))
              ]))
            : (_ctx.activeEditTab === 'groups')
              ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                  _createElementVNode("div", _hoisted_186, [
                    _createElementVNode("div", _hoisted_187, _toDisplayString(_ctx.$t('Participant.Edit.Groups')), 1),
                    (_ctx.allGroups && _ctx.allGroups.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_188, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allGroups, (group) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: group.Id,
                              class: "tab-group-item"
                            }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "tab-group-checkbox",
                                checked: _ctx.editForm.GroupIds.includes(group.Id),
                                onChange: ($event: any) => (_ctx.ToggleGroupMembership(group.Id))
                              }, null, 40, _hoisted_189),
                              _createTextVNode(" " + _toDisplayString(group.Name), 1)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_190, _toDisplayString(_ctx.$t('Participant.Edit.NoGroups')), 1)),
                    _createElementVNode("button", _hoisted_191, [
                      _createVNode(_component_router_link, {
                        to: { name: 'groups' },
                        class: "hyperLink"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Participant.Edit.ManageGroups')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : (_ctx.activeEditTab === 'myInformation')
                ? (_openBlock(), _createElementBlock("div", _hoisted_192, [
                    _createElementVNode("div", _hoisted_193, [
                      _createElementVNode("div", _hoisted_194, _toDisplayString(_ctx.$t('Participant.Edit.MyInformation')), 1),
                      (_ctx.editForm.ExtraInformations && _ctx.editForm.ExtraInformations.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editForm.ExtraInformations, (info, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: idx,
                                class: "tab-info-field"
                              }, [
                                _createElementVNode("label", _hoisted_196, _toDisplayString(info.KeyValue), 1),
                                _createElementVNode("div", _hoisted_197, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.editForm.ExtraInformations[idx].KeyInformation) = $event),
                                    type: "text",
                                    class: _normalizeClass(["form-control", { 'tab-info-input--readonly': info.Source?.toLowerCase() === 'registration' }]),
                                    disabled: info.Source?.toLowerCase() === 'registration',
                                    title: info.Source?.toLowerCase() === 'registration' ? _ctx.$t('Participant.Edit.EditableFromRegistration') : ''
                                  }, null, 10, _hoisted_198), [
                                    [_vModelText, _ctx.editForm.ExtraInformations[idx].KeyInformation]
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_199, _toDisplayString(_ctx.$t('Participant.Edit.NoExtraInformation')), 1))
                    ])
                  ]))
                : (_ctx.activeEditTab === 'tickets')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_200, [
                      _createElementVNode("div", _hoisted_201, [
                        _createElementVNode("div", _hoisted_202, _toDisplayString(_ctx.$t('Participant.Edit.TicketsCheckIns')), 1),
                        (_ctx.editForm.ParticipantTicketDetails && _ctx.editForm.ParticipantTicketDetails.length)
                          ? (_openBlock(), _createElementBlock("table", _hoisted_203, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('Participant.Edit.TicketName')), 1),
                                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('Participant.Edit.PurchaseAssignDate')), 1),
                                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('Participant.Edit.CheckInTime')), 1),
                                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('Participant.Edit.AssignedBy')), 1),
                                  _cache[71] || (_cache[71] = _createElementVNode("th", null, null, -1))
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editForm.ParticipantTicketDetails, (ticket, idx) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                    _createElementVNode("td", null, _toDisplayString(ticket.TicketName), 1),
                                    _createElementVNode("td", null, _toDisplayString(_ctx.FormatTicketDate(ticket.TicketIssuedDate)), 1),
                                    _createElementVNode("td", null, _toDisplayString(ticket.CheckedInUtc ? _ctx.FormatDateTime(ticket.CheckedInUtc) : '-'), 1),
                                    _createElementVNode("td", null, _toDisplayString(ticket.TicketIssuedBy), 1),
                                    _createElementVNode("td", _hoisted_204, [
                                      _createElementVNode("a", {
                                        href: "javascript:void(0)",
                                        class: "revoke-ticket-link",
                                        onClick: ($event: any) => (_ctx.RevokeTicket(idx))
                                      }, _toDisplayString(_ctx.$t('Participant.Edit.RevokeTicket')), 9, _hoisted_205)
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_206, _toDisplayString(_ctx.$t('Participant.Edit.NoTickets')), 1)),
                        _createElementVNode("div", _hoisted_207, _toDisplayString(_ctx.$t('Participant.Edit.SessionCheckIns')), 1),
                        (_ctx.editForm.ParticipantSessionCheckInDetails && _ctx.editForm.ParticipantSessionCheckInDetails.length)
                          ? (_openBlock(), _createElementBlock("table", _hoisted_208, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('Participant.Edit.ProgramName')), 1),
                                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('Participant.Edit.CheckInTime')), 1)
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editForm.ParticipantSessionCheckInDetails, (session, idx) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                    _createElementVNode("td", null, _toDisplayString(session.Title), 1),
                                    _createElementVNode("td", null, _toDisplayString(session.CheckedInUtc ? _ctx.FormatDateTime(session.CheckedInUtc) : '-'), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_209, _toDisplayString(_ctx.$t('Participant.Edit.NoTickets')), 1))
                      ])
                    ]))
                  : (_ctx.activeEditTab === 'notes')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
                        _createElementVNode("div", _hoisted_211, [
                          _createElementVNode("div", _hoisted_212, _toDisplayString(_ctx.$t('Participant.Edit.Notes')), 1),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.editNoteText) = $event)),
                            class: "form-control tab-note-textarea",
                            placeholder: _ctx.$t('Participant.Edit.NotePlaceholder'),
                            rows: "4"
                          }, null, 8, _hoisted_213), [
                            [_vModelText, _ctx.editNoteText]
                          ]),
                          (_ctx.editNoteUpdatedBy || _ctx.editNoteUpdatedOn)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_214, [
                                (_ctx.editNoteUpdatedBy)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_215, _toDisplayString(_ctx.editNoteIsUpdated
                  ? _ctx.$t('Participant.Edit.NoteUpdatedBy')
                  : _ctx.$t('Participant.Edit.NoteCreatedBy')) + " - " + _toDisplayString(_ctx.editNoteUpdatedBy), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.editNoteUpdatedOn)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_216, _toDisplayString(_ctx.editNoteIsUpdated
                  ? _ctx.$t('Participant.Edit.NoteUpdatedOn')
                  : _ctx.$t('Participant.Edit.NoteCreatedOn')) + " - " + _toDisplayString(_ctx.editNoteUpdatedOn), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show-drawer", "onConfirm"])
  ]))
}